import { SxProps } from "@mui/system";
import { ThemeV2 } from "../../../util/types";

export const typoStyle = (
  isMarkDownText: boolean,
  theme: ThemeV2,
  variant: "hint" | "error" | "label" = "hint",
): SxProps => ({
  color:
    variant === "error"
      ? theme.tokens.color.feedback.error
      : variant === "label"
        ? theme.tokens.color.text.primary
        : theme.tokens.color.action.primary,
  fontSize: theme.tokens.typography.size,
  fontWeight: theme.tokens.typography.weight.regular,
  textAlign: isMarkDownText ? "left" : "center",
  // Increase spacing between Markdown paragraphs
  "& p:not(:last-child)": {
    marginBottom: 3, // theme spacing (e.g., 24px)
  },
  fontFamily: theme.tokens.typography.fontFamily,
  "& :is(h1, h2, h3, h4, h5, h6, strong, em, del, a, hr)": {
    color:
      variant === "error"
        ? theme.tokens.color.feedback.error
        : theme.tokens.color.text.accent,
  },
  "& hr": {
    borderColor: theme.tokens.color.text.accent,
  },
  "& li::marker": {
    color: theme.tokens.color.text.accent,
  },
});
